const LAST_GOOGLE_SIGN_IN_STORAGE_KEY = 'lastGoogleSignInUser';
const LAST_GOOGLE_SIGN_IN_TTL_MS = 1000 * 60 * 60 * 24 * 30;

export const clearLastGoogleSignInUserCache = () => {
  try {
    localStorage.removeItem(LAST_GOOGLE_SIGN_IN_STORAGE_KEY);
  } catch {
    // Ignore storage errors and fail closed by returning no cached user.
  }
};

export const getLastGoogleSignInUserCache = () => {
  try {
    const raw = localStorage.getItem(LAST_GOOGLE_SIGN_IN_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || (!parsed.name && !parsed.email)) {
      clearLastGoogleSignInUserCache();
      return null;
    }

    if (!parsed.updatedAt || typeof parsed.updatedAt !== 'string') {
      clearLastGoogleSignInUserCache();
      return null;
    }

    const updatedAtMs = new Date(parsed.updatedAt).getTime();
    if (Number.isNaN(updatedAtMs)) {
      clearLastGoogleSignInUserCache();
      return null;
    }

    if (Date.now() - updatedAtMs > LAST_GOOGLE_SIGN_IN_TTL_MS) {
      clearLastGoogleSignInUserCache();
      return null;
    }

    return parsed;
  } catch {
    clearLastGoogleSignInUserCache();
    return null;
  }
};

export const cacheLastGoogleSignInUser = user => {
  const firstName = user?.profile?.firstName || '';
  const lastName = user?.profile?.lastName || '';
  const fullName = `${firstName} ${lastName}`.trim();
  const email = user?.emails?.[0]?.address || '';
  const avatarUrl = user?.profile?.avatarUrl || '';

  if (!email && !fullName) {
    return;
  }

  try {
    localStorage.setItem(
      LAST_GOOGLE_SIGN_IN_STORAGE_KEY,
      JSON.stringify({
        name: fullName,
        email,
        avatarUrl,
        updatedAt: new Date().toISOString(),
      }),
    );
  } catch {
    clearLastGoogleSignInUserCache();
  }
};
